import { render, staticRenderFns } from "./ResourceBrokersPage.html?vue&type=template&id=2ba0db06&external"
import script from "./ResourceBrokersPage.js?vue&type=script&lang=js&external"
export * from "./ResourceBrokersPage.js?vue&type=script&lang=js&external"
import style0 from "./ResourceBrokersPage.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports